import { render, staticRenderFns } from "./ShiftItemActions.vue?vue&type=template&id=6dccd173&"
import script from "./ShiftItemActions.vue?vue&type=script&lang=js&"
export * from "./ShiftItemActions.vue?vue&type=script&lang=js&"
import style0 from "./ShiftItemActions.vue?vue&type=style&index=0&id=6dccd173&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports